export function getBallsThrown(igracRezultat) {
  if (!igracRezultat) return 120;
  const izmjena = igracRezultat.izmjena;
  if (!izmjena) return 120;
  let hitac = 0;
  if (izmjena.ukupnoHitac) {
    hitac = parseInt(izmjena.ukupnoHitac);
  } else if (izmjena.set && izmjena.bacanje) {
    hitac = (parseInt(izmjena.set) - 1) * 30 + parseInt(izmjena.bacanje);
  }
  if (!hitac || hitac <= 0) return 120;
  if (izmjena.tip === 'izlaz') return Math.max(1, hitac - 1);
  if (izmjena.tip === 'ulaz') return Math.max(1, 120 - (hitac - 1));
  return 120;
}

export function getEquivalent120(cunjevi, kugle) {
  if (!kugle || kugle === 0) return 0;
  return (cunjevi / kugle) * 120;
}

export function getPlayerAverage120(utakmiceIgraca, igracId) {
  let ukupnoCunjeva = 0;
  let ukupnoKugli = 0;
  utakmiceIgraca.forEach(utakmica => {
    const r = utakmica.rezultati?.find(r => r.igracId === igracId);
    if (!r) return;
    ukupnoCunjeva += r.ukupno || 0;
    ukupnoKugli += getBallsThrown(r);
  });
  if (ukupnoKugli === 0) return 0;
  return Math.round(((ukupnoCunjeva / ukupnoKugli) * 120) * 100) / 100;
}

export function getProsjekPoSetu120(utakmiceIgraca, igracId) {
  const avg = getPlayerAverage120(utakmiceIgraca, igracId);
  return Math.round(avg / 4);
}

export function getFormaIgraca(utakmiceIgraca, igracId) {
  const zadnjih5 = [...utakmiceIgraca]
    .sort((a, b) => b.datum?.localeCompare(a.datum))
    .slice(0, 5);
  return zadnjih5.map(u => {
    const r = u.rezultati?.find(r => r.igracId === igracId);
    const kugle = getBallsThrown(r);
    const ekv = r ? Math.round(getEquivalent120(r.ukupno || 0, kugle)) : 0;
    return {
      datum: u.datum,
      protivnik: u.protivnik,
      ukupno: r?.ukupno || 0,
      ekv120: ekv,
      rezultatEkipe: u.ekipaBodovi === 2 ? 'P' : u.ekipaBodovi === 1 ? 'R' : 'G',
    };
  }).reverse();
}

export function getTrendIgraca(utakmiceIgraca, igracId) {
  if (utakmiceIgraca.length < 3) return 'neutral';
  // Ukupni prosjek sezone (normalizovan na 120)
  let totalCunjeva = 0, totalKugle = 0;
  utakmiceIgraca.forEach(u => {
    const r = u.rezultati?.find(r => r.igracId === igracId);
    if (!r) return;
    totalCunjeva += r.ukupno || 0;
    totalKugle += getBallsThrown(r);
  });
  const ukupniProsjek = totalKugle > 0 ? (totalCunjeva / totalKugle) * 120 : 0;
  // Prosjek zadnje 3 utakmice
  const zadnje3 = [...utakmiceIgraca]
    .sort((a, b) => b.datum?.localeCompare(a.datum))
    .slice(0, 3);
  let recentCunjeva = 0, recentKugle = 0;
  zadnje3.forEach(u => {
    const r = u.rezultati?.find(r => r.igracId === igracId);
    if (!r) return;
    recentCunjeva += r.ukupno || 0;
    recentKugle += getBallsThrown(r);
  });
  const recentProsjek = recentKugle > 0 ? (recentCunjeva / recentKugle) * 120 : 0;
  if (recentProsjek > ukupniProsjek + 10) return 'up';
  if (recentProsjek < ukupniProsjek - 10) return 'down';
  return 'neutral';
}

export function getBestSerija(utakmiceKluba) {
  const sortirane = [...utakmiceKluba].sort((a, b) => a.datum?.localeCompare(b.datum));
  let maxPobjeda = 0, trenutnoPobjeda = 0;
  let maxBezPoraza = 0, trenutnoBezPoraza = 0;
  let maxBezPobjede = 0, trenutnoBezPobjede = 0;
  sortirane.forEach(u => {
    if (u.ekipaBodovi === 2) {
      trenutnoPobjeda++;
      trenutnoBezPoraza++;
      trenutnoBezPobjede = 0;
    } else if (u.ekipaBodovi === 1) {
      trenutnoPobjeda = 0;
      trenutnoBezPoraza++;
      trenutnoBezPobjede++;
    } else {
      trenutnoPobjeda = 0;
      trenutnoBezPoraza = 0;
      trenutnoBezPobjede++;
    }
    maxPobjeda = Math.max(maxPobjeda, trenutnoPobjeda);
    maxBezPoraza = Math.max(maxBezPoraza, trenutnoBezPoraza);
    maxBezPobjede = Math.max(maxBezPobjede, trenutnoBezPobjede);
  });
  return { maxPobjeda, maxBezPoraza, maxBezPobjede };
}

export function getStatistikeProtivnika(utakmiceKluba) {
  const mapa = {};
  utakmiceKluba.forEach(u => {
    if (!mapa[u.protivnik]) {
      mapa[u.protivnik] = { protivnik: u.protivnik, odigrano: 0, pobjede: 0, remiji: 0, porazi: 0, ukupnoCunjeva: 0, ukupnoProtivnik: 0 };
    }
    const p = mapa[u.protivnik];
    p.odigrano++;
    p.ukupnoCunjeva += u.ekipaUkupno || 0;
    p.ukupnoProtivnik += u.protivnikCunjevi || 0;
    if (u.ekipaBodovi === 2) p.pobjede++;
    else if (u.ekipaBodovi === 1) p.remiji++;
    else p.porazi++;
  });
  return Object.values(mapa).sort((a, b) => b.odigrano - a.odigrano);
}

export function getProsjekDomaci(utakmiceIgraca, igracId) {
  let ukupnoCunjeva = 0, ukupnoKugli = 0;
  utakmiceIgraca.filter(u => u.domaci === true).forEach(u => {
    const r = u.rezultati?.find(r => r.igracId === igracId);
    if (!r) return;
    ukupnoCunjeva += r.ukupno || 0;
    ukupnoKugli += getBallsThrown(r);
  });
  if (ukupnoKugli === 0) return 0;
  return Math.round((ukupnoCunjeva / ukupnoKugli) * 120);
}

export function getProsjekGost(utakmiceIgraca, igracId) {
  let ukupnoCunjeva = 0, ukupnoKugli = 0;
  utakmiceIgraca.filter(u => u.domaci === false).forEach(u => {
    const r = u.rezultati?.find(r => r.igracId === igracId);
    if (!r) return;
    ukupnoCunjeva += r.ukupno || 0;
    ukupnoKugli += getBallsThrown(r);
  });
  if (ukupnoKugli === 0) return 0;
  return Math.round((ukupnoCunjeva / ukupnoKugli) * 120);
}
